// Flax — Live Specials — app logic (preview theme)
(function () {
const STORE_CART_ADD = '/cart/add';
const STORE_CART = '/cart';
const CART_WINDOW = 'flax_cart';
const CATEGORY_LABEL = { bedroom: 'Bedroom', 'living-room': 'Living Room', kids: 'Kids & Teens' };
const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
function money(n) {
return '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
function defaultVariant(variants) {
return variants.reduce((min, v) => (v.price < min.price ? v : min), variants[0]);
}
function cartAddUrl(variantId) {
return `${STORE_CART_ADD}?id=${variantId}&quantity=1`;
}
function matchVariant(product, selected) {
return product.variants.find(v =>
product.optionNames.every(name => v.options[name] === selected[name])
) || defaultVariant(product.variants);
}
function optionPillGroups(p, selected) {
if (p.optionNames.length === 0) return '';
return p.optionNames.map(optName => {
const values = [...new Set(p.variants.map(v => v.options[optName]))];
if (values.length < 2) return '';
return `
<div class="option-group" data-option-group="${optName}">
<span class="option-label">${optName}</span>
<div class="option-pills">
${values.map(val => `<button type="button" class="variant-pill${val === selected[optName] ? ' active' : ''}" data-option-name="${optName}" data-option-value="${val}">${val}</button>`).join('')}
</div>
</div>
`;
}).join('');
}
function productCard(p) {
const variant = defaultVariant(p.variants);
const selected = { ...variant.options };
const hasDiscount = variant.compareAt && variant.compareAt > variant.price;
const savings = hasDiscount ? (variant.compareAt - variant.price) : 0;
const images = p.images.slice(0, 6);
const galleryImgs = images
.map((src, i) => `<img src="${src}" alt="${p.name} — view ${i + 1}" loading="${i === 0 ? 'eager' : 'lazy'}" decoding="async" data-idx="${i}">`)
.join('');
const dots = images.length > 1
? `<div class="card-dots" data-dots>${images.map((_, i) => `<span class="${i === 0 ? 'active' : ''}"></span>`).join('')}</div>`
: '';
const galleryHint = images.length > 1 ? `<span class="gallery-hint" aria-hidden="true">${images.length}</span>` : '';
return `
<article class="product-card" data-category="${p.category}" data-handle="${p.handle}" data-reveal>
<div class="card-media">
${hasDiscount ? `<span class="card-badge" data-badge>SAVE ${money(savings)}</span>` : '<span class="card-badge" data-badge style="display:none"></span>'}
${galleryHint}
<div class="card-gallery" data-gallery tabindex="0" aria-label="${p.name} photos, scroll to see more">
${galleryImgs}
</div>
${dots}
</div>
<div class="card-body">
<span class="card-eyebrow">${CATEGORY_LABEL[p.category] || p.category}</span>
<h3 class="card-title">${p.name}</h3>
${p.detail ? `<p class="card-detail">${p.detail}</p>` : ''}
<div class="card-options" data-options>
${optionPillGroups(p, selected)}
</div>
<div class="card-price-row">
<span class="card-price" data-price-display>${money(variant.price)}</span>
${hasDiscount ? `<span class="card-price-compare" data-compare-display>${money(variant.compareAt)}</span>` : '<span class="card-price-compare" data-compare-display style="display:none"></span>'}
</div>
<div class="card-cta-row">
<a class="btn btn-primary btn-add" data-add-btn href="${cartAddUrl(variant.id)}" data-variant-id="${variant.id}" target="${CART_WINDOW}" rel="noopener">Add to Cart</a>
<a class="btn btn-ghost btn-view" href="${p.url}" target="_blank" rel="noopener" aria-label="View full details for ${p.name}">
<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M7 17L17 7M17 7H8M17 7V16"/></svg>
</a>
</div>
</div>
</article>
`;
}
function renderGrid(el, products) {
if (!products.length) {
el.innerHTML = '<div class="empty-state">// NO UNITS IN THIS CATEGORY RIGHT NOW</div>';
return;
}
el.innerHTML = products.map(productCard).join('');
wireGalleries(el);
wireOptions(el);
wireAddButtons(el);
observeReveals(el.querySelectorAll('[data-reveal]'));
}
function wireGalleries(scope) {
scope.querySelectorAll('[data-gallery]').forEach(gallery => {
const dotsWrap = gallery.parentElement.querySelector('[data-dots]');
if (!dotsWrap) return;
const dots = dotsWrap.querySelectorAll('span');
let ticking = false;
gallery.addEventListener('scroll', () => {
if (ticking) return;
ticking = true;
requestAnimationFrame(() => {
const idx = Math.round(gallery.scrollLeft / gallery.clientWidth);
dots.forEach((d, i) => d.classList.toggle('active', i === idx));
ticking = false;
});
}, { passive: true });
});
}
function wireOptions(scope) {
scope.querySelectorAll('.product-card').forEach(card => {
const handle = card.dataset.handle;
const product = PRODUCTS.find(p => p.handle === handle);
if (!product) return;
const initialVariant = defaultVariant(product.variants);
const selected = { ...initialVariant.options };
function applyVariant(variant) {
const hasDiscount = variant.compareAt && variant.compareAt > variant.price;
const priceEl = card.querySelector('[data-price-display]');
const compareEl = card.querySelector('[data-compare-display]');
const badge = card.querySelector('[data-badge]');
priceEl.textContent = money(variant.price);
if (hasDiscount) {
compareEl.style.display = '';
compareEl.textContent = money(variant.compareAt);
if (badge) { badge.style.display = ''; badge.textContent = 'SAVE ' + money(variant.compareAt - variant.price); }
} else {
compareEl.style.display = 'none';
if (badge) badge.style.display = 'none';
}
const addBtn = card.querySelector('[data-add-btn]');
addBtn.href = cartAddUrl(variant.id);
addBtn.dataset.variantId = variant.id;
}
card.querySelectorAll('[data-option-group]').forEach(group => {
group.querySelectorAll('.variant-pill').forEach(pill => {
pill.addEventListener('click', () => {
group.querySelectorAll('.variant-pill').forEach(p => p.classList.remove('active'));
pill.classList.add('active');
selected[pill.dataset.optionName] = pill.dataset.optionValue;
applyVariant(matchVariant(product, selected));
});
});
});
});
}
let cartCount = 0;
function wireAddButtons(scope) {
scope.querySelectorAll('[data-add-btn]').forEach(btn => {
btn.addEventListener('click', () => {
cartCount += 1;
showToast('Added to cart — opening checkout');
updateCartDock();
});
});
}
function showToast(message) {
const toast = document.querySelector('[data-toast]');
if (!toast) return;
toast.querySelector('span').textContent = message;
toast.classList.add('show');
clearTimeout(toast._t);
toast._t = setTimeout(() => toast.classList.remove('show'), 2400);
}
function updateCartDock() {
const dock = document.querySelector('[data-cart-dock]');
const countEl = document.querySelector('[data-cart-dock-count]');
const headerBadge = document.querySelector('[data-cart-badge]');
if (countEl) countEl.textContent = cartCount;
if (headerBadge) {
headerBadge.textContent = cartCount;
headerBadge.classList.toggle('show', cartCount > 0);
}
if (dock) dock.classList.toggle('show', cartCount > 0);
}
function initFilters(grid) {
const chips = document.querySelectorAll('[data-filter]');
const countEl = document.querySelector('[data-filter-count]');
chips.forEach(chip => {
chip.addEventListener('click', () => {
chips.forEach(c => c.classList.remove('active'));
chip.classList.add('active');
const filter = chip.dataset.filter;
const filtered = filter === 'all' ? PRODUCTS : PRODUCTS.filter(p => p.category === filter);
renderGrid(grid, filtered);
if (countEl) countEl.textContent = `${filtered.length} SET${filtered.length === 1 ? '' : 'S'}`;
});
});
}
let revealObserver;
function getRevealObserver() {
if (revealObserver) return revealObserver;
revealObserver = new IntersectionObserver((entries) => {
entries.forEach(entry => {
if (entry.isIntersecting) {
entry.target.classList.add('in-view');
revealObserver.unobserve(entry.target);
}
});
}, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
return revealObserver;
}
function observeReveals(nodeList) {
if (prefersReducedMotion) {
nodeList.forEach(n => n.classList.add('in-view'));
return;
}
const obs = getRevealObserver();
const groups = new Map();
nodeList.forEach(n => {
const parent = n.parentElement;
const idx = groups.get(parent) || 0;
n.style.transitionDelay = `${Math.min(idx * 70, 420)}ms`;
groups.set(parent, idx + 1);
obs.observe(n);
});
}
function initCounters() {
const counters = document.querySelectorAll('[data-counter]');
if (!counters.length) return;
const obs = new IntersectionObserver((entries) => {
entries.forEach(entry => {
if (!entry.isIntersecting) return;
obs.unobserve(entry.target);
const el = entry.target;
const target = parseFloat(el.dataset.counter);
const prefix = el.dataset.prefix || '';
const suffix = el.dataset.suffix || '';
const decimals = el.dataset.decimals ? parseInt(el.dataset.decimals, 10) : 0;
if (prefersReducedMotion) {
el.textContent = prefix + target.toFixed(decimals) + suffix;
return;
}
const duration = 1100;
const start = performance.now();
function tick(now) {
const p = Math.min((now - start) / duration, 1);
const eased = 1 - Math.pow(1 - p, 3);
el.textContent = prefix + (target * eased).toFixed(decimals) + suffix;
if (p < 1) requestAnimationFrame(tick);
}
requestAnimationFrame(tick);
});
}, { threshold: 0.6 });
counters.forEach(c => obs.observe(c));
}
function initHeroScroll() {
const hero = document.querySelector('.hero');
const heroBg = document.querySelector('.hero-bg img');
if (!hero || !heroBg || prefersReducedMotion) return;
let ticking = false;
function update() {
const vh = window.innerHeight;
const progress = Math.min(Math.max(window.scrollY / (vh * 0.9), 0), 1);
heroBg.style.transform = `scale(${1.12 - progress * 0.12})`;
hero.style.setProperty('--hero-progress', progress.toFixed(3));
ticking = false;
}
window.addEventListener('scroll', () => {
if (!ticking) { ticking = true; requestAnimationFrame(update); }
}, { passive: true });
update();
}
document.addEventListener('DOMContentLoaded', () => {
const grid = document.querySelector('[data-grid]');
if (grid) {
renderGrid(grid, PRODUCTS);
initFilters(grid);
const countEl = document.querySelector('[data-filter-count]');
if (countEl) countEl.textContent = `${PRODUCTS.length} SETS`;
}
observeReveals(document.querySelectorAll('[data-reveal-static]'));
initCounters();
initHeroScroll();
const header = document.querySelector('.header');
if (header) {
window.addEventListener('scroll', () => {
header.classList.toggle('scrolled', window.scrollY > 8);
}, { passive: true });
}
document.querySelectorAll('[data-cart-link]').forEach(a => {
a.href = STORE_CART;
a.target = CART_WINDOW;
a.rel = 'noopener';
});
document.querySelectorAll('[data-scroll-to]').forEach(el => {
el.addEventListener('click', (e) => {
const target = document.querySelector(el.dataset.scrollTo);
if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
});
});
});
})();